/* eslint-disable no-unused-vars */
export enum Banner {
  VALUATION = "valuation",
  MORTGAGE = "mortgage",
  SELLER = "seller",
}
